// ============================================================
// ROUND MATCH STATS — SRS §2.4
// ============================================================
//
// Points & Tiers system. The pool records the CUMULATIVE points
// per element accumulated during a MATCH3 round (each match emits
// points = basePoints(groupSize) × comboMultiplier(comboDepth)).
//
// Resetting at the start of MATCH3 matches the Client behaviour
// (`Game._startRound` clears pRes/aRes before each round).
//
// Conversion to a powerLevel uses `pointsToLevel(points)` (see
// constants.ts) — applied lazily on the validation / display side
// rather than baked into storage.

import type { RoundMatchStats } from './types.ts';

export function emptyStats(): RoundMatchStats {
  return {};
}

/**
 * Fold a new batch of per-element point contributions into the round pool.
 * `matchStats` comes from `M3Board._onChainComplete.pointsByElement` —
 * keyed by ElementType (as string or number), value = points this chain
 * awarded for that element. Returns a fresh RoundMatchStats (does not
 * mutate input).
 */
export function updateStats(
  stats: RoundMatchStats,
  matchStats: Record<string | number, number>,
): RoundMatchStats {
  const next: RoundMatchStats = { ...stats };
  for (const [key, points] of Object.entries(matchStats)) {
    const el = Number(key);
    if (!Number.isFinite(el) || el <= 0) continue;
    if (!Number.isFinite(points) || points <= 0) continue;
    next[el] = (next[el] || 0) + points;
  }
  return next;
}
